const KEY = 'mbr_checkout_resume';

export function saveCheckoutResume(draft) {
  try {
    if (!draft?.cartItems?.length) return;
    sessionStorage.setItem(KEY, JSON.stringify({ ...draft, savedAt: Date.now() }));
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadCheckoutResume() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!Array.isArray(data?.cartItems) || data.cartItems.length === 0) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearCheckoutResume() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
